import {I2ospError} from 'metaserver/static/js/encrypted_folder/crypto/errors';

export enum CompareResult {
  LeftSmallerThanRight = -1,
  Equal = 0,
  LeftBiggerThanRight = 1,
}

export function i2osp(n: number, w: number): Uint8Array<ArrayBuffer> {
  if (w <= 0) {
    throw new I2ospError('too small size');
  }
  if (w !== 2) {
    throw new I2ospError('only allowed with w = 2');
  }
  if (n >= 256 ** w) {
    throw new I2ospError('too large integer');
  }
  return new Uint8Array([(n >> 8) & 0xff, n & 0xff]);
}

export function base64UrlDecode(input: string): Uint8Array<ArrayBuffer> {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  const paddingLength = 4 - (base64.length % 4);
  const paddedBase64 = paddingLength === 4 ? base64 : base64 + '='.repeat(paddingLength);
  const binaryString = atob(paddedBase64);
  const uint8Array = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  return uint8Array;
}

export function base64UrlEncode(uint8Array: Uint8Array): string {
  // @ts-ignore
  const base64 = btoa(String.fromCharCode.apply(null, uint8Array));
  return base64.replace(/\+/g, '-').replace(/\//g, '_');
}

export function concat(parts: Uint8Array<ArrayBuffer>[]): Uint8Array<ArrayBuffer> {
  const length = parts.map((part) => part.byteLength).reduce((partialSum, a) => partialSum + a, 0);
  const concatenatedArray = new Uint8Array(length);
  let offset = 0;

  for (const part of parts) {
    concatenatedArray.set(part, offset);
    offset += part.byteLength;
  }

  return concatenatedArray;
}

// BigInt is not available in all browsers
export function bigIntCompare(a: Uint8Array, b: Uint8Array): CompareResult {
  const length = Math.max(a.length, b.length);
  const aPadded = new Uint8Array(length);
  const bPaddded = new Uint8Array(length);
  aPadded.set(a, length - a.length);
  bPaddded.set(b, length - b.length);

  for (let i = 0; i < length; i++) {
    if (aPadded[i] < bPaddded[i]) {
      return CompareResult.LeftSmallerThanRight;
    } else if (aPadded[i] > bPaddded[i]) {
      return CompareResult.LeftBiggerThanRight;
    }
  }
  return CompareResult.Equal;
}
